<template>
  <div class="week-calendar-wrapper">
    <!-- 顶部周切换栏 -->
    <div class="week-switch-bar">
      <van-icon name="arrow-left" @click="prevWeek" size="20" color="#246bfa" />
      <span class="week-switch-label">{{ weekDateRange }}</span>
      <van-icon name="arrow" @click="nextWeek" size="20" color="#246bfa" />
      <button class="week-switch-btn" @click="goToCurrentWeek">本周</button>
    </div>
    <div class="calendar-main">
      <!-- 左侧：时间轴 -->
      <div class="calendar-time-col">
        <div
          class="time-header-spacer"
          style="
            box-shadow: 0 2px 8px rgba(36, 107, 250, 0.06);
            border-bottom: 1px solid #ededed;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 13px;
            color: #b0b0b0;
            font-weight: 400;
          "
        >
          {{ currentMonth }}
        </div>
        <div class="time-label" v-for="t in timeAxis" :key="t">{{ t }}</div>
      </div>
      <!-- 右侧：课表内容区 -->
      <div class="calendar-content-area">
        <div class="calendar-header-sticky">
          <!-- <div class="header-time-spacer"></div> -->
          <div class="day-header" v-for="(day, i) in calendarDays" :key="i">
            <div class="day-week">{{ day.week }}</div>
            <div class="day-date-lunar">
              <span class="day-date">{{ day.date }}</span>
              <span class="day-lunar">{{ day.lunar }}</span>
            </div>
          </div>
        </div>
        <div class="calendar-content">
          <div
            class="calendar-day-col"
            v-for="(day, dayIdx) in weekDays"
            :key="dayIdx"
          >
            <!-- <div class="calendar-header-placeholder"></div> -->
            <template v-for="(t, slotIdx) in timeAxis" :key="t">
              <template v-if="getCourseStartInSlot(dayIdx, slotIdx)">
                <div
                  class="course-block"
                  :style="{
                    height:
                      getCourseSpanPx(getCourseStartInSlot(dayIdx, slotIdx)) +
                      'px',
                    borderLeftColor: getCourseStartInSlot(dayIdx, slotIdx).color,
                  }"
                >
                  <div class="course-title">
                    {{ getCourseStartInSlot(dayIdx, slotIdx).name }}
                  </div>
                  <div class="course-location">
                    {{ getCourseStartInSlot(dayIdx, slotIdx).location }}
                  </div>
                </div>
              </template>
              <template v-else-if="isAnyCourseCoveredInSlot(dayIdx, slotIdx)">
                <!-- 被覆盖的格子不渲染 -->
              </template>
              <template v-else>
                <div class="calendar-cell"></div>
              </template>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, computed, onMounted } from "vue";
import { Icon } from "vant";
import dayjs from "dayjs";
import Lunar from "lunar-javascript";
import { querySyLessonsList } from "@/api/user";
import { useRoute } from "vue-router";

const route = useRoute();

function getMonday(date = new Date()) {
  const d = new Date(date);
  const day = d.getDay() || 7;
  if (day !== 1) d.setDate(d.getDate() - day + 1);
  d.setHours(0, 0, 0, 0);
  return d;
}
const semesterStart = ref(getMonday());
const currentWeek = ref(1);
const totalWeeks = 20;
const prevWeek = () => {
  currentWeek.value--;
  queryClassDetailData();
};
const nextWeek = () => {
  currentWeek.value++;
  queryClassDetailData();
};
const goToCurrentWeek = () => {
  currentWeek.value = 1; // 可根据实际逻辑调整
  queryClassDetailData();
};

const state = reactive({
  list: [],
  params: {
    userId: route?.query?.userId,
  },
});

onMounted(() => {
  if (route?.query?.token) {
    localStorage.setItem("token", route?.query?.token);
  }
  queryClassDetailData();
});

const unique = (arr) => [...new Set(arr)];

const queryClassDetailData = async () => {
  const [startDate, endDate] = weekDateRange.value.split(" - ");

  state.list = [];
  try {
    const result = await querySyLessonsList({
      ...state.params,
      startDate: dayjs(startDate).format("YYYY-MM-DD"),
      endDate: dayjs(endDate).format("YYYY-MM-DD"),
    });
    console.log(result);
    if (result.code === "00") {
      const list = result?.data ?? [];
      const typeList = list.map(item => item.type)

      const typeUnique = unique(typeList)
      const defaultColor = "#E4D2E6";
      const colors = ["#E4D2E6","#FFFACD", "#F1D2CF", "#EAECC6", "#F6E9D3", "#D3E9D3", "#BBD6CE", "#D2EADB", "#F9DFEB"]

      state.list  = list.map(item => ({
        day: item.weekDay - 1,
        startTime: dayjs(`${dayjs().format("YYYY-MM-DD")} ${item.startTime}`).format("HH:mm"),
        endTime: dayjs(`${dayjs().format("YYYY-MM-DD")} ${item.endTime}`).format("HH:mm"),
        name: `${item.courseName}`,
        location: item.classRoomName,
        type: typeUnique[item.type],
        color: typeUnique.findIndex(type => type === item.type) == -1 ? defaultColor : colors[typeUnique.findIndex(type => type === item.type)],
      }));
    } else {
      state.list = [];
    }
  } catch (error) {
    console.log("error:>>>", error);
    state.list = [];
  }
};

function formatDate(date) {
  const y = date.getFullYear();
  const m = (date.getMonth() + 1).toString().padStart(2, "0");
  const d = date.getDate().toString().padStart(2, "0");
  return `${y}/${m}/${d}`;
}
const weekDateRange = computed(() => {
  const start = new Date(semesterStart.value);
  start.setDate(start.getDate() + (currentWeek.value - 1) * 7);
  const end = new Date(start);
  end.setDate(start.getDate() + 6);
  return `${formatDate(start)} - ${formatDate(end)}`;
});

const currentMonth = computed(() => {
  const start = new Date(semesterStart.value);
  start.setDate(start.getDate() + (currentWeek.value - 1) * 7);
  return dayjs(start).format("YYYY/MM");
});

// 顶部栏日期数据
const calendarDays = computed(() => {
  const start = new Date(semesterStart.value);
  start.setDate(start.getDate() + (currentWeek.value - 1) * 7);
  const days = [];
  for (let i = 0; i < 7; i++) {
    const date = new Date(start);
    date.setDate(start.getDate() + i);
    days.push({
      week: ["周一", "周二", "周三", "周四", "周五", "周六", "周日"][i],
      date: date.getDate().toString(),
      lunar: getLunarDate(date), // 使用函数获取农历数据
    });
  }
  return days;
});

function getLunarDate(date) {
  const lunar = Lunar.Solar.fromYmd(
    date.getFullYear(),
    date.getMonth() + 1,
    date.getDate()
  ).getLunar();
  return lunar.getDayInChinese();
}

const selectedDay = ref(2);

// 生成时间轴（05:00~22:30，步长30分钟）
function generateTimeAxis() {
  const times = [];
  let hour = 5,
    min = 0;
  while (hour < 22 || (hour === 22 && min <= 30)) {
    times.push(
      `${hour.toString().padStart(2, "0")}:${min === 0 ? "00" : "30"}`
    );
    min += 30;
    if (min === 60) {
      min = 0;
      hour++;
    }
  }
  return times;
}
const timeAxis = generateTimeAxis();

const weekDays = computed(() => calendarDays.value.map((d) => d.week));


function parseTime(str) {
  const [h, m] = str.split(":").map(Number);
  return h * 60 + m;
}
function getTimeRange(idx) {
  const start = parseTime(timeAxis[idx]);
  const end =
    idx + 1 < timeAxis.length ? parseTime(timeAxis[idx + 1]) : start + 30;
  return [start, end];
}
function isCourseStartInSlot(course, slotIdx) {
  const [slotStart, slotEnd] = getTimeRange(slotIdx);
  const courseStart = parseTime(course.startTime);
  return courseStart >= slotStart && courseStart < slotEnd;
}
function isCourseCoveredInSlot(course, slotIdx) {
  const [slotStart, slotEnd] = getTimeRange(slotIdx);
  const courseStart = parseTime(course.startTime);
  const courseEnd = parseTime(course.endTime);
  return (
    courseStart < slotEnd &&
    courseEnd > slotStart &&
    !isCourseStartInSlot(course, slotIdx)
  );
}
function getCourseSpanPx(course) {
  const start = parseTime(course.startTime);
  const end = parseTime(course.endTime);
  return ((end - start) / 30) * 48;
}
function getCourseStartInSlot(dayIdx, slotIdx) {
  return state.list.find(
    (c) => c.day === dayIdx && isCourseStartInSlot(c, slotIdx)
  );
}
function isAnyCourseCoveredInSlot(dayIdx, slotIdx) {
  return state.list.some(
    (c) => c.day === dayIdx && isCourseCoveredInSlot(c, slotIdx)
  );
}
const getCourseColor = (type) => {
  const colorMap = {
    meeting: "#a3c9fa",
    break: "#b8e0d2",
    chinese: "#b5b8f8",
    math: "#f9c6c9",
    default: "#bdbdbd",
  };
  
  return colorMap[type] || colorMap.default;
};
</script>

<style lang="scss" scoped>
.week-calendar-wrapper {
  background: #fff;
  min-height: 100vh;
  overflow-x: hidden;
}
.calendar-main {
  display: flex;
  min-height: 100vh;
  overflow-y: auto;
}
.calendar-time-col {
  width: 70px;
  flex-shrink: 0;
  background: #fff;
  border-right: 1px solid #f0f0f0;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
.time-header-spacer {
  height: 56px;
  width: 100%;
  background: #fff;
}
.time-label {
  height: 48px;
  line-height: 48px;
  text-align: right;
  font-size: 15px;
  color: #b0b0b0;
  padding-right: 12px;
  border-bottom: 1px solid #f4f4f4;
  background: #fff;
  font-family: "Menlo", "Consolas", "monospace";
  font-weight: 400;
}
.calendar-content-area {
  flex: 1;
  min-width: 0;
  overflow-x: auto;
  overflow-y: hidden;
  position: relative;
  background: #fff;
}
.calendar-header-sticky {
  display: flex;
  position: sticky;
  top: 0;
  z-index: 10;
  background: #fff;
  box-shadow: 0 2px 8px rgba(36, 107, 250, 0.06);
  border-bottom: 1px solid #ededed;
}
.header-time-spacer {
  width: 70px;
  flex-shrink: 0;
  height: 56px;
  background: #fff;
}
.day-header {
  width: 96px;
  flex-shrink: 0;
  height: 56px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #fff;
  border-bottom: 1px solid #ededed;
  .day-week {
    font-size: 13px;
    color: #999;
    margin-bottom: 2px;
    font-weight: 400;
  }
  .day-date-lunar {
    display: flex;
    align-items: baseline;
    justify-content: center;
    gap: 4px;
    .day-date {
      font-size: 28px;
      font-weight: bold;
      color: #888;
      line-height: 1;
    }
    .day-lunar {
      font-size: 13px;
      color: #bbb;
      margin-left: 2px;
    }
  }
}
.calendar-content {
  display: flex;
}
.calendar-day-col {
  width: 96px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
}
.calendar-header-placeholder {
  height: 56px;
  width: 100%;
}
.calendar-cell {
  height: 48px;
  border-bottom: 1px solid #f4f4f4;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0 8px;
  background: #fff;
}
.course-block {
  background: #f5f8ff;
  border-left: 4px solid #a3c9fa;
  border-radius: 6px;
  min-width: 60px;
  min-height: 32px;
  font-size: 16px;
  color: #246bfa;
  font-weight: 600;
  box-shadow: none;
  display: flex;
  flex-direction: column;
  justify-content: center;
  .course-title {
    font-weight: 600;
    margin-bottom: 2px;
    font-size: 16px;
    color: #333;
  }
  .course-location {
    font-size: 13px;
    color: #b0b0b0;
    font-weight: 400;
  }
}
.week-switch-bar {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 16px 0 8px 0;
  background: #fff;
  border-bottom: 1px solid #ededed;
}
.week-switch-btn {
  background: #f7f8fa;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  padding: 4px 14px;
  font-size: 15px;
  color: #246bfa;
  cursor: pointer;
  transition: background 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
}
.week-switch-btn:hover {
  background: #eaf3ff;
}
.week-switch-label {
  font-size: 16px;
  color: #333;
  font-weight: 600;
  margin: 0 8px;
}
</style> 